var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3838 21.5814C16.3838 25.9674 21.1319 28.7087 24.9302 26.5157C26.6932 25.4978 27.7792 23.617 27.7792 21.5814C27.7792 17.1953 23.0311 14.4539 19.2325 16.647C17.4698 17.6647 16.3838 19.5457 16.3838 21.5814Z",
    stroke: "white",
    strokeWidth: 3.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70996 35.2557V7.90698H41.4541V35.2557H2.70996Z",
    stroke: "white",
    strokeWidth: 3.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54785 42.0931H48.292V14.7441",
    stroke: "white",
    strokeWidth: 3.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.3fbf7c79108f1974839119213396e8c9.svg";
export { ForwardRef as ReactComponent };